import React from "react";
import { MarkdownPage } from "./MarkdownPage";

export const Arquitecture = () => (
  <MarkdownPage file="Arquitecture.md" showMermaid />
);
